import React, {Component} from 'react';
import {Provider} from 'mobx-react';
import {useStrict} from 'mobx';
import {Route, Router} from 'react-router-dom';
import stores from '../../stores';
import history from '../../history';
import '../../sass/base.scss';
import HotSwappingIntlProvider from '../../components/hotIntlProvider';
import App from '../app';

useStrict(true);

class BaseContainer extends Component {
    render() {
        return (
            <Provider {...stores}>
                <HotSwappingIntlProvider>
                    <Router history={history}>
                        <Route path="/" component={App}/>
                    </Router>
                </HotSwappingIntlProvider>
            </Provider>
        );
    }
}

export default BaseContainer;
